import data from "./Transactions.json";


export const contractABI = data.abi;
export const contractAddress = "0x5273766C87917d47Eeb270eD3875a90Ab7b65745";